<template>
  <nav>
    <figure class="image-logo">
      <a href="/">
        <img :src="imagePath" height="65px" />
      </a>
    </figure>
    <transition
      name="slide"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <ul class="wrapper slidein" v-if="navShow">
        <li v-for="(item, index) in list" :key="'item' + index">
          <!-- font awesome icon with a rotating animation -->
          <i
            v-if="subMenuExists(item)"
            class="fas fa-chevron-circle-right chevronDisplay"
            :class="{ open: item.open }"
            @click="clickNavTitle(item)"
          ></i>
          <!-- The list title with the click event for toggling the open status -->
          <div
            @mouseover="mouseOverNav(item)"
            @mouseleave="mouseLeaveNav(item)"
          >
            <!-- <div class="title" @click="clickNavTitle(item)">
            {{ item.title }}
          </div>-->
            <router-link
              tag="div"
              class="title"
              :to="item.path"
              @click.native="clickNavTitle(item)"
            >
              {{ item.title }}
            </router-link>
            <!-- renders the ListItem Component for each list element -->
            <NavListItem :list="item" @myevent="hideNav" />
          </div>
        </li>
      </ul>
    </transition>
    <div class="btn" @click="navShow = !navShow">
      <i class="fas fa-bars"></i>
    </div>
  </nav>
</template>

<script>
import NavListItem from "./NavListItem";

export default {
  props: ["imagePath"],

  data: () => {
    return {
      windowWidth: window.innerWidth,
      mobileNavViewBreakpoint: 900, // px
      navShow: true,
      list: [
        {
          title: "Home",
          open: false,
          path: "/",
        },
        {
          title: "Tools",
          open: false,
          path: "",
          sublist: [
            { name: "Staking ROI Calculator", path: "/stakingcalculator" },
            { name: "Validator ROI Calculator", path: "/validatorcalculator" },
            { name: "Staking Optimizer", path: "/stakingoptimizer" },
          ],
        },
        {
          title: "Tutorials",
          open: false,
          path: "/tutorials",
        },
        {
          title: "Papers",
          open: false,
          path: "/papers",
        },
        {
          title: "Blog",
          open: false,
          path: "/blog",
        },
        {
          title: "Community",
          open: false,
          path: "/community",
        },
      ],
    };
  },
  components: {
    NavListItem,
  },

  methods: {
    mouseOverNav: function (listObject) {
      if (this.windowWidth > this.mobileNavViewBreakpoint) {
        listObject.open = true;
      }
    },
    mouseLeaveNav: function (listObject) {
      if (this.windowWidth > this.mobileNavViewBreakpoint) {
        listObject.open = false;
      }
    },
    clickNavTitle: function (listObject) {
      if (this.windowWidth <= this.mobileNavViewBreakpoint) {
        if (this.subMenuExists(listObject)) {
          listObject.open = !listObject.open;
        } else {
          this.navShow = false;
        }
      }
    },
    subMenuExists: function (listObject) {
      return "sublist" in listObject;
    },

    hideNav(listObject) {
      if (this.windowWidth <= this.mobileNavViewBreakpoint) {
        this.navShow = false;
      }
      listObject.open = false;
    },

    enter(el) {
      // set the element to his natural hight
      el.style.height = "auto";

      /*
          get the calculated height.
          getComputedStyle returns an object containing all the CSS properties
          of the element after all active styles have been loaded and the basic
          calculations have been performed.

          We need the height after all basic calculations have been performed,
          then the height of each element here is dynamically,
          based on the number of items in the sublist.
        */
      const height = getComputedStyle(el).height;

      // set the height to zero for the opening animation
      el.style.height = 0;

      /*
          Force the repaint to make sure the animation is triggered correctly,
          then you can fire the method getComputedStyle again.
          This is not necessary, but sometimes the animation may not start depending on the case.
        */
      getComputedStyle(el);

      /*
          Set the height from the element to the calculated height.
          With setTimeout you make sure the browser has finished the painting
          after setting the height to zero.
        */
      setTimeout(() => {
        el.style.height = height;
      });
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    leave(el) {
      /*
          Same as with the enter method, but only the other way around.
        */
      el.style.height = getComputedStyle(el).height;

      getComputedStyle(el);

      setTimeout(() => {
        el.style.height = 0;
      });
    },
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > this.mobileNavViewBreakpoint) {
        this.navShow = true;
      }
    };
  },
  created() {
    if (this.windowWidth <= this.mobileNavViewBreakpoint) {
      this.navShow = false;
    }
  },
};
</script>

<style scoped lang="scss">
nav {
  .image-logo {
    max-width: 200px;
  }
}
@media (min-width: 901px) {
  .chevronDisplay {
    display: none;
  }
  nav {
    height: 70px;
    width: 100%;
    color: #141a3c;
    display: flex;
    padding-bottom: 15px;

    ul {
      width: 100%;
      display: flex;
      height: 100%;
      align-items: center;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 0;
      justify-content: flex-end;

      li {
        list-style-type: none;
        width: auto;
        height: 100%;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 18px;
        padding: 0 3px;

        .title {
          padding: 0 20px;
          margin: 0 auto;
          padding-top: 20px;
          padding-bottom: 10px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    i {
      visibility: hidden;
    }
    .btn {
      display: none;
    }
  }
}
@media (max-width: 900px) {
  nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .wrapper {
      list-style: none;
      background-color: #fefefe;
      box-shadow: 0 2px rgba($color: #000000, $alpha: 0.15);
      border-radius: 4px;
      overflow: hidden;
      order: 3;
      width: 100%;

      li {
        position: relative;
        color: #555;
        border-top: 1px solid #dedede;
        cursor: pointer;

        .title {
          padding: 10px 0;
          text-indent: 20px;
        }

        /*
          CSS definition for the icon
          If the open status from the clicked element equal to true,
          then the open class is connected and the icon rotates
          90 deg to the bottom, otherwise back to the default position.
        */
        i {
          visibility: visible;
          position: absolute;
          top: 14px;
          right: 10px;
          transition: transform 0.5s ease-in-out;

          &.open {
            transform: rotateZ(90deg);
          }
        }

        &:hover {
          color: #273272;
          background-color: #d7dcee;
        }
      }
    }
    .btn {
      display: block;
      font-size: 30px;
      cursor: pointer;
      margin-right: 10px;
      margin-top: 10px;
    }

    nav figure {
      order: 1;
    }

    nav .btn {
      order: 2;
    }
    nav ul {
      order: 3;
    }
  }

  //.slide-enter-active, .slide-leave-active {
  .slide-enter-active {
    transition: height 0.4s ease-in-out;
    overflow: hidden;
  }
}
</style>
